import { ITicketAttachment } from "../models/Tickets/Ticket";

/** Only images get an inline preview - everything else is download-only. */
export function isImageAttachment(contentType?: string): boolean {
  return (contentType || "").toLowerCase().startsWith("image/");
}

export function formatAttachmentSize(bytes: number): string {
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(0)} KB`;
  return `${(bytes / (1024 * 1024)).toFixed(2)} MB`;
}

export function sortAttachmentsNewestFirst(
  attachments: ITicketAttachment[],
): ITicketAttachment[] {
  return [...attachments].sort(
    (a, b) => new Date(b.created).getTime() - new Date(a.created).getTime(),
  );
}
